import type {TemplateTextFieldDefinition} from "./templateTextFields";
import {downloadResponseFile, readDownloadErrorMessage} from "../../downloadFile";
import {authorizationHeaders} from "../../api/authorization";

type BadgeTemplatePreviewRequest = {
    frontTemplateUrl: string;
    backTemplateUrl: string;
    textFields: TemplateTextFieldDefinition[];
    qrCodeX: number;
    qrCodeY: number;
};

type CertificateTemplatePreviewRequest = {
    templateUrl: string;
    textFields: TemplateTextFieldDefinition[];
};

export const buildBadgeTemplatePreviewUrl = (eventId: number | string) =>
    `/api/events/${encodeURIComponent(String(eventId))}/template-preview/badge`;

export const buildCertificateTemplatePreviewUrl = (eventId: number | string) =>
    `/api/events/${encodeURIComponent(String(eventId))}/template-preview/certificate`;

const downloadTemplatePreview = async (
    url: string,
    payload: BadgeTemplatePreviewRequest | CertificateTemplatePreviewRequest,
    authToken: string | undefined,
    fallbackFileName: string
) => {
    const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            ...authorizationHeaders(authToken)
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) {
        throw new Error(await readDownloadErrorMessage(response, "Preview could not be generated."));
    }

    return downloadResponseFile(response, fallbackFileName);
};

export const downloadBadgeTemplatePreview = (
    eventId: number | string,
    payload: BadgeTemplatePreviewRequest,
    authToken?: string
) => downloadTemplatePreview(
    buildBadgeTemplatePreviewUrl(eventId),
    payload,
    authToken,
    `Badge_preview_${eventId}.pdf`);

export const downloadCertificateTemplatePreview = (
    eventId: number | string,
    payload: CertificateTemplatePreviewRequest,
    authToken?: string
) => downloadTemplatePreview(
    buildCertificateTemplatePreviewUrl(eventId),
    payload,
    authToken,
    `Certificate_preview_${eventId}.pdf`);
